export class AzureMarketplaceWebhookInputSubscription {
    'id';
    'name';
    'publisherId';
    'offerId';
    'planId';
    'quantity';
    'beneficiary';
    'purchaser';
    'allowedCustomerOperations';
    'sessionMode';
    'isFreeTrial';
    'isTest';
    'sandboxType';
    'saasSubscriptionStatus';
    'term';
    'autoRenew';
    'created';
    'lastModified';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "publisherId",
            "baseName": "publisherId",
            "type": "string",
            "format": ""
        },
        {
            "name": "offerId",
            "baseName": "offerId",
            "type": "string",
            "format": ""
        },
        {
            "name": "planId",
            "baseName": "planId",
            "type": "string",
            "format": ""
        },
        {
            "name": "quantity",
            "baseName": "quantity",
            "type": "number",
            "format": ""
        },
        {
            "name": "beneficiary",
            "baseName": "beneficiary",
            "type": "AzureMarketplaceWebhookInputSubscriptionBeneficiary",
            "format": ""
        },
        {
            "name": "purchaser",
            "baseName": "purchaser",
            "type": "AzureMarketplaceWebhookInputSubscriptionPurchaser",
            "format": ""
        },
        {
            "name": "allowedCustomerOperations",
            "baseName": "allowedCustomerOperations",
            "type": "Array<AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum>",
            "format": ""
        },
        {
            "name": "sessionMode",
            "baseName": "sessionMode",
            "type": "AzureMarketplaceWebhookInputSubscriptionSessionModeEnum",
            "format": ""
        },
        {
            "name": "isFreeTrial",
            "baseName": "isFreeTrial",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isTest",
            "baseName": "isTest",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sandboxType",
            "baseName": "sandboxType",
            "type": "AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum",
            "format": ""
        },
        {
            "name": "saasSubscriptionStatus",
            "baseName": "saasSubscriptionStatus",
            "type": "AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum",
            "format": ""
        },
        {
            "name": "term",
            "baseName": "term",
            "type": "AzureMarketplaceWebhookInputSubscriptionTerm",
            "format": ""
        },
        {
            "name": "autoRenew",
            "baseName": "autoRenew",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "created",
            "baseName": "created",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastModified",
            "baseName": "lastModified",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return AzureMarketplaceWebhookInputSubscription.attributeTypeMap;
    }
    constructor() {
    }
}
export var AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum;
(function (AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum) {
    AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum["Delete"] = "Delete";
    AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum["Update"] = "Update";
    AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum["Read"] = "Read";
})(AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum || (AzureMarketplaceWebhookInputSubscriptionAllowedCustomerOperationsEnum = {}));
export var AzureMarketplaceWebhookInputSubscriptionSessionModeEnum;
(function (AzureMarketplaceWebhookInputSubscriptionSessionModeEnum) {
    AzureMarketplaceWebhookInputSubscriptionSessionModeEnum["None"] = "None";
})(AzureMarketplaceWebhookInputSubscriptionSessionModeEnum || (AzureMarketplaceWebhookInputSubscriptionSessionModeEnum = {}));
export var AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum;
(function (AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum) {
    AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum["None"] = "None";
})(AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum || (AzureMarketplaceWebhookInputSubscriptionSandboxTypeEnum = {}));
export var AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum;
(function (AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum) {
    AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum["Subscribed"] = "Subscribed";
    AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum["Suspended"] = "Suspended";
    AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum["Unsubscribed"] = "Unsubscribed";
})(AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum || (AzureMarketplaceWebhookInputSubscriptionSaasSubscriptionStatusEnum = {}));
